// DS: C23
/** The footer used in most pages */
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeContext, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import classnames from 'classnames';
import { URLS } from '@wix/da-url';
import FacebookIcon from '@wix/da-ds/pkg/Icons/Facebook';
import InstagramIcon from '@wix/da-ds/pkg/Icons/Instagram';
import TwitterIcon from '@wix/da-ds/pkg/Icons/Twitter';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Logo from '../Logo';
import ErrorBoundary from '../ErrorBoundary';
import { VisuallyHidden } from '../a11y';
import s from './SiteFooter.scss';
var menuItems = [
    { key: 'siteFooter.menu.about', href: URLS.ABOUT },
    { key: 'siteFooter.menu.contact', href: URLS.CONTACT },
    { key: 'siteFooter.menu.coreMembership', href: URLS.CORE_MEMBERSHIP },
    { key: 'siteFooter.menu.careers', href: URLS.CAREERS },
    { key: 'siteFooter.menu.developers', href: URLS.DEVELOPERS },
    { key: 'siteFooter.menu.advertise', href: URLS.ADVERTISE },
    { key: 'siteFooter.menu.termsOfService', href: URLS.TOS },
    { key: 'siteFooter.menu.etiquette', href: URLS.ETIQUETTE },
    { key: 'siteFooter.menu.privacyPolicy', href: URLS.PRIVACY },
    { key: 'siteFooter.menu.copyrightPolicy', href: URLS.COPYRIGHT },
    { key: 'siteFooter.menu.helpAndFaq', href: URLS.HELP },
];
var socialButtons = [
    {
        icon: FacebookIcon,
        href: 'https://www.facebook.com/deviantart/',
        title: 'DeviantArt Facebook',
    },
    {
        icon: InstagramIcon,
        href: 'https://www.instagram.com/deviantart/',
        title: 'DeviantArt Instagram',
    },
    {
        icon: TwitterIcon,
        href: 'https://twitter.com/DeviantArt',
        title: 'DeviantArt Twitter',
    },
];
var copyrightKey = 'siteFooter.copyright';
var allRightsReservedKey = 'siteFooter.allRightsReserved';
var SiteFooter = function (_a) {
    var className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var theme = useContext(ThemeContext);
    var isDarkTheme = theme === ThemeOptions.DARK;
    return (React.createElement("footer", { className: classnames(s['root'], className), role: "contentinfo" },
        React.createElement(ErrorBoundary, { hideOnFail: true },
            React.createElement("div", { className: s['columns'] },
                React.createElement("div", { className: classnames(s['logo-block'], s['column']) },
                    React.createElement("a", { href: "https://deviantart.com/", title: "DeviantArt - Homepage" },
                        React.createElement(VisuallyHidden, null, "DeviantArt - Homepage"),
                        React.createElement(Logo, { className: s['logo'], markColor: isDarkTheme ? 'white' : 'black', textColor: isDarkTheme ? 'white' : 'black', size: "tiny" }))),
                React.createElement("div", { className: classnames(s['multicolumn'], s['column']) }, menuItems.map(function (item) { return (React.createElement("div", { className: s['menu__block__item'], key: item.key },
                    React.createElement("a", { className: s['link'], href: item.href, title: t(item.key) }, t(item.key)))); })),
                React.createElement("div", { className: classnames(s['social-block'], s['column']) },
                    React.createElement("div", { className: s['social-networks'] }, socialButtons.map(function (sb, index) { return (React.createElement("a", { key: index, className: s['social-networks__button'], href: sb.href, title: sb.title },
                        React.createElement(VisuallyHidden, null, sb.title),
                        React.createElement(sb.icon, { size: IconSize.MEDIUM, className: classnames(s['social-networks__icon'], s['link']) }))); }))),
                isMobile && (React.createElement("div", { className: s['copyright'] },
                    React.createElement("div", null, t(copyrightKey, {
                        year: new Date().getFullYear(),
                    })),
                    React.createElement("div", { className: s['separator'] }),
                    React.createElement("div", null, t(allRightsReservedKey))))),
            !isMobile && (React.createElement("div", { className: s['copyright'] },
                React.createElement("div", null, t(copyrightKey, { year: new Date().getFullYear() })),
                React.createElement("div", null, t(allRightsReservedKey)))))));
};
SiteFooter.displayName = 'SiteFooter';
export default React.memo(SiteFooter);
//# sourceMappingURL=SiteFooter.js.map